import { Avatar, Box, Typography } from '@mui/material';
import { GangRoleBadge } from '../atoms/GangRoleBadge';

interface GangMemberHeaderProps {
  fullName: string;
  email: string;
  role: 'leader' | 'member';
}

const getInitials = (name: string) => {
  if (!name) return 'U';
  return (
    name
      .split(' ')
      .filter(Boolean)
      .map(part => part[0]?.toUpperCase() ?? '')
      .join('')
      .slice(0, 2) || 'U'
  );
};

export const GangMemberHeader = ({
  fullName,
  email,
  role,
}: GangMemberHeaderProps) => {
  const displayEmail = email?.trim() || 'Email unavailable';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Avatar
        sx={{
          mr: 2,
          width: 40,
          height: 40,
          bgcolor: role === 'leader' ? 'primary.main' : 'secondary.main',
        }}
      >
        {getInitials(fullName)}
      </Avatar>
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="subtitle1" fontWeight="medium">
            {fullName}
          </Typography>
          <GangRoleBadge role={role} />
        </Box>
        <Typography variant="body2" color="text.secondary">
          {displayEmail}
        </Typography>
      </Box>
    </Box>
  );
};
